import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Box } from '@chakra-ui/react';
import { RFNodeIcon, RFSvg } from '../../base';
import { useNodeTemplate } from '../../../hooks';
import { RFConfigContext } from '../../../contexts';
import { RECYCLE_CONFIG } from './RFRecycleNode.config';
/**
 * Component renders "recycle" type of node of ReactFlow.
 * @param props : props come from ReactFlow.
 * See RF_NODE_TYPES.
 */
const RFRecycleNodeFC = ({ id, data, type, selected, isConnectable = true }) => {
    const { isInspector } = useContext(RFConfigContext) ?? {};
    const { isValidTemplate, template, renderPorts, renderError } = useNodeTemplate({
        id,
        selected,
        templateCode: data.templateCode,
        config: RECYCLE_CONFIG
    });
    return isValidTemplate ? (_jsxs(_Fragment, { children: [_jsx(Box, { "data-templateid": data.templateCode, children: _jsx(RFNodeIcon, { id: id, padding: "0px", rfType: type, isSelected: selected, isInspector: isInspector, templateCode: data.templateCode ?? '', children: _jsx(RFSvg, { name: template?.icon, width: 36, height: 36 }) }) }), renderPorts(isConnectable, isInspector)] })) : (_jsx(_Fragment, { children: renderError() }));
};
export const RFRecycleNode = RFRecycleNodeFC;
//# sourceMappingURL=RFRecycleNode.js.map